import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Ocm from "../components/register/ocm";
import Ogb from "../components/register/ogb";
import Mng from "../components/register/mng";
import Mtg from "../components/register/mtg";
import Mgb from "../components/register/mgb";
import Mueg from "../components/register/mueg";
import Vmz from "../components/register/vmz";
import Login from "../components/login/login";
import Home from "../components/home";
import Policy from "../components/policy";
import { service } from "../utils/constant";

const OpenRoute = () => {
  if (service === "ocm") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "ogb") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Ogb />} />
        <Route path="/login" element={<Ogb />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mng") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mng />} />
        <Route path="/login" element={<Mng />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mtg") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mtg />} />
        <Route path="/login" element={<Mtg />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mgb") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mgb />} />
        <Route path="/login" element={<Mgb />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "mueg") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Mueg />} />
        <Route path="/login" element={<Mueg />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  } else if (service === "vmz") {
    return (
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/register" element={<Vmz />} />
        <Route path="/login" element={<Vmz />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="*" element={<Navigate to="/register" />} />
      </Routes>
    );
  }
};

export default OpenRoute;
